// Admin-only per-key descriptions for loise client config. Env-independent.
// NOT persisted to KV/D1 and NOT read by runtime code — shown in the admin config table.
export const clientDescription = {
    adsHeight: 'bottom ad height (px)',
    adsRecommendDistance: 'px of forward Recommend-feed scroll between in-feed ads',
    allowAds: 'master on/off for all ads (hides every ad placement when false)',
    allowRecommendAds: 'on/off for in-feed Recommend ads (requires allowAds)',
    commentAvatarSize: 'comment avatar size (px)',
    commentDescMax: 'max comment length (chars)',
    commonBottomMinHeight: 'bottom bar min height (px)',
    commonMinHeight: 'common content min height (px)',
    commonTopMinHeight: 'top bar min height (px)',
    dragDropImageSize: 'drag-drop image resize target (px)',
    exploreLimit: 'items fetched per Explore batch',
    messageMax: 'max message length (chars)',
    postAvatarSize: 'post author avatar size (px)',
    postDescMax: 'max post caption length (chars)',
    postMaxUploadSize: 'max post upload size in bytes (25MB)',
    profileAvatarSize: 'profile avatar size (px)',
    profileAvatarUploadSize: 'profile avatar resize target (px)',
    profileDescMax: 'max profile bio length (chars)',
    profileFilterLength: 'number of filter rows shown on a profile',
    profileImageMaxBytes: 'max profile image/thumbnail size in bytes (1MB)',
    profileMinHeight: 'profile header min height (px)',
    profilePostUploadSize: 'profile post image resize target (px)',
    profileThumbnailUploadSize: 'profile thumbnail resize target (px)',
    recommendLimit: 'posts fetched per Recommend-feed batch',
    searchFilterDebounceMs: 'debounce before applying Search filters (ms)',
    searchLimit: 'items fetched per Search batch',
    signupEmailMax: 'max email length at signup (chars)',
    signupMinAge: 'minimum age allowed at signup (years)',
    signupPasswordMax: 'max password length at signup (chars)',
    signupUsernameMax: 'max username length at signup (chars)',
    trendingFilterDebounceMs: 'debounce before applying Trending filters (ms)',
    trendingLimit: 'items fetched per Trending batch',
    userAvatarSize: 'user-list avatar size (px)',
    userListLimit: 'users fetched per user-list batch',
};
